export type colorTuple = [number, number, number];

export type ThemeColor = {
	primary: string;
	secondary: string;
	tertiary: string;
	primaryLight: string;
	labelDark: string;
	primaryLabel: string;
};

export enum TButtonColorType {
	LIGHT = 'light',
	DARK = 'dark',
}

export interface IThemeConfig {
	fontFamily: string;
	primaryColor: string;
	backgroundImage?: string;
	buttonColorType?: TButtonColorType;
}

export interface IThemeConfigResponse {
	type: string;
	description?: string;
	themeConfig: IThemeConfig;
}
